export default __webpack_public_path__ + "9b44382f409c66b0673857a2621ae045.jpg";